import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { SubmissionError } from 'redux-form';
import Button from 'components/buttons/Button';
import { ReactComponent as OutlookLogo } from 'icons/outlook.svg';
import { createEmailKnownImapConfig, getAccountEmailConfigs } from 'redux/actions/emailConfigActions';
import Dialog from 'components/modals/Dialog';
import DialogTitle from 'components/modals/DialogTitle';
import EmailKnownImapConfigForm from './EmailKnownImapConfigForm';


class EmailKnownImapConfigCreate extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    createEmailKnownImapConfig: PropTypes.func.isRequired,
    getAccountEmailConfigs: PropTypes.func.isRequired,
    accountId: PropTypes.string.isRequired,
    onEmailCreateSuccess: PropTypes.func.isRequired,
    accessTypeLabel: PropTypes.string.isRequired,
    accessType: PropTypes.string.isRequired,
    accountEmailConfig: PropTypes.shape({
      email: PropTypes.string,
      sender_name: PropTypes.string,
      password: PropTypes.string,
      access_type: PropTypes.string,
      total_number_of_emails_per_day: PropTypes.number,
      delay_between_each_email_sent: PropTypes.number,
      is_primary: PropTypes.bool,
    }),
  };

  static defaultProps = {
    className: '',
    accountEmailConfig: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  async onSubmit(formData) {
    try {
      await this.props.createEmailKnownImapConfig(
        this.props.accountId,
        {
          email: formData.email,
          sender_name: formData.sender_name,
          password: formData.password,
          access_type: this.props.accessType,
          total_number_of_emails_per_day: formData.total_number_of_emails_per_day,
          delay_between_each_email_sent: formData.delay_between_each_email_sent,
          is_primary: formData.is_primary,
          signature: formData.signature,
        },
      );
      this.toggle();
      this.props.onEmailCreateSuccess(this.props.accountEmailConfig);
      await this.props.getAccountEmailConfigs(this.props.accountId);
    } catch (error) {
      if (error.errors) {
        const nonFieldErrors = error.errors.non_field_errors;
        if (nonFieldErrors) {
          /* eslint-disable-next-line no-underscore-dangle */
          error.errors._error = nonFieldErrors;
        }
        throw new SubmissionError(error.errors);
      }
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    return (
      <div className={this.props.className}>
        <Button
          className="mb-2 pl-2"
          color="secondary"
          variant="outlinedWhite"
          startIcon={<OutlookLogo />}
          style={{ justifyContent: 'flex-start' }}
          onClick={this.toggle}
          fullWidth
          disabled
        >
          {this.props.accessTypeLabel}
        </Button>
        <Dialog
          open={this.state.isOpen}
          onBackdropClick={this.toggle}
          size="large"
        >
          <DialogTitle id="dialog-title" disableTypography>
            Add {this.props.accessTypeLabel} email config
          </DialogTitle>
          <EmailKnownImapConfigForm
            toggleModal={this.toggle}
            actionType="create"
            onSubmit={data => this.onSubmit(data)}
          />
        </Dialog>
      </div>
    );
  }
}

export default compose(
  connect(
    state => ({
      accountEmailConfig: state.accountEmailConfig,
      config: state.config,
    }),
    { createEmailKnownImapConfig, getAccountEmailConfigs },
  ),
  withNamespaces('common'),
)(EmailKnownImapConfigCreate);
